var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 330,
    height: 216,
    viewBox: "0 0 330 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2440",
    "data-name": "Rect\\xE1ngulo 2440",
    width: 330,
    height: 216,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2428",
    "data-name": "Rect\\xE1ngulo 2428",
    width: 74.075,
    height: 74.02,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2429",
    "data-name": "Rect\\xE1ngulo 2429",
    width: 102.965,
    height: 62.335,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2431",
    "data-name": "Rect\\xE1ngulo 2431",
    width: 49.974,
    height: 26.166,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2432",
    "data-name": "Rect\\xE1ngulo 2432",
    width: 49.973,
    height: 19.646,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2433",
    "data-name": "Rect\\xE1ngulo 2433",
    width: 189.148,
    height: 85.637,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2436",
    "data-name": "Rect\\xE1ngulo 2436",
    width: 23.906,
    height: 24.489,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2437",
    "data-name": "Rect\\xE1ngulo 2437",
    width: 43.747,
    height: 43.715,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2438",
    "data-name": "Rect\\xE1ngulo 2438",
    width: 40.981,
    height: 40.952,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3198",
    "data-name": "Grupo 3198",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3197",
    "data-name": "Grupo 3197",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3196",
    "data-name": "Grupo 3196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3195",
    "data-name": "Grupo 3195",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3173",
    "data-name": "Grupo 3173",
    transform: "translate(24.617)",
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3172",
    "data-name": "Grupo 3172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3171",
    "data-name": "Grupo 3171",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4382",
    "data-name": "Trazado 4382",
    d: "M56.554,72.53a35.765,35.765,0,1,1,35.79-35.765A35.819,35.819,0,0,1,56.554,72.53",
    transform: "translate(-19.515 0.245)",
    fill: "#bde4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4383",
    "data-name": "Trazado 4383",
    d: "M56.8,2.49A34.52,34.52,0,1,1,22.252,37.01,34.533,34.533,0,0,1,56.8,2.49M56.8,0A37.01,37.01,0,1,0,93.836,37.01,37.065,37.065,0,0,0,56.8,0",
    transform: "translate(-19.761)",
    fill: "#887db3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4384",
    "data-name": "Trazado 4384",
    d: "M55.257,74.83c-6.794,0-12.536-6.207-12.536-13.555a13.6,13.6,0,0,1,9.022-12.8,16.4,16.4,0,0,1-.26-2.876,16.808,16.808,0,0,1,16.8-16.784A16.609,16.609,0,0,1,80.5,34.108a21.1,21.1,0,0,1,37.32,19.538,10.625,10.625,0,0,1-.528,21.238L55.257,74.83",
    transform: "translate(10.499 5.871)",
    fill: "#bde4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4385",
    "data-name": "Trazado 4385",
    d: "M98.764,25.469a19.838,19.838,0,0,1,17.2,29.8,9.259,9.259,0,0,1,1.575-.149,9.381,9.381,0,1,1,0,18.762L55.5,73.83c-6.326,0-11.291-5.846-11.291-12.309a12.36,12.36,0,0,1,9.23-11.947A15.527,15.527,0,0,1,80.955,36.546,19.863,19.863,0,0,1,98.764,25.469m0-2.49A22.2,22.2,0,0,0,80.531,32.4a17.837,17.837,0,0,0-12.008-4.585A18.056,18.056,0,0,0,50.482,45.848a17.133,17.133,0,0,0,.128,2.084,14.853,14.853,0,0,0-8.89,13.59c0,8.022,6.312,14.8,13.783,14.8l62.03.055a11.871,11.871,0,0,0,2.287-23.521A22.327,22.327,0,0,0,98.764,22.979",
    transform: "translate(10.253 5.626)",
    fill: "#887db3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3176",
    "data-name": "Grupo 3176",
    transform: "translate(212.334 89.013)",
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3175",
    "data-name": "Grupo 3175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3174",
    "data-name": "Grupo 3174",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4386",
    "data-name": "Trazado 4386",
    d: "M186.067,132.287c-7.924,0-14.62-7.247-14.62-15.827a15.887,15.887,0,0,1,10.718-15.009,19.333,19.333,0,0,1-.339-3.559,19.682,19.682,0,0,1,19.667-19.652A19.448,19.448,0,0,1,216,84.658a24.772,24.772,0,0,1,43.822,22.981,12.358,12.358,0,0,1-.275,24.714l-73.484-.065",
    transform: "translate(-170.201 -71.261)",
    fill: "#bde4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4387",
    "data-name": "Trazado 4387",
    d: "M237.563,74a23.5,23.5,0,0,1,20.37,35.307,10.971,10.971,0,0,1,1.865-.177,11.113,11.113,0,1,1,0,22.226l-73.483-.065c-7.494,0-13.376-6.926-13.376-14.583a14.641,14.641,0,0,1,10.934-14.151,18.395,18.395,0,0,1,32.592-15.435A23.53,23.53,0,0,1,237.563,74m0-2.49a25.856,25.856,0,0,0-21.523,11.4,20.675,20.675,0,0,0-14.3-5.668,20.929,20.929,0,0,0-20.912,20.9,20.129,20.129,0,0,0,.193,2.755A17.133,17.133,0,0,0,170.448,116.7c0,9.254,7.266,17.073,15.867,17.073l73.483.065a13.6,13.6,0,0,0,2.085-27.046,25.988,25.988,0,0,0-24.321-35.29",
    transform: "translate(-170.447 -71.506)",
    fill: "#887db3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3179",
    "data-name": "Grupo 3179",
    transform: "translate(212.334 142.671)",
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3178",
    "data-name": "Grupo 3178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3177",
    "data-name": "Grupo 3177",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2430",
    "data-name": "Rect\\xE1ngulo 2430",
    d: "M6.958,0H40.525a6.957,6.957,0,0,1,6.957,6.957V16.72a6.957,6.957,0,0,1-6.957,6.957H6.958A6.958,6.958,0,0,1,0,16.719V6.958A6.958,6.958,0,0,1,6.958,0Z",
    transform: "translate(1.246 1.245)",
    fill: "#bde4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4388",
    "data-name": "Trazado 4388",
    d: "M210.508,117.1a7.418,7.418,0,0,1,7.421,7.415v6.356a7.418,7.418,0,0,1-7.421,7.415H180.359a7.418,7.418,0,0,1-7.421-7.415v-6.356a7.418,7.418,0,0,1,7.421-7.415Zm0-2.49H180.359a9.92,9.92,0,0,0-9.912,9.905v6.356a9.92,9.92,0,0,0,9.912,9.905h30.148a9.92,9.92,0,0,0,9.912-9.905v-6.356a9.92,9.92,0,0,0-9.912-9.905",
    transform: "translate(-170.447 -114.611)",
    fill: "#887db3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3182",
    "data-name": "Grupo 3182",
    transform: "translate(280.027 116.572)",
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3181",
    "data-name": "Grupo 3181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3180",
    "data-name": "Grupo 3180",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4389",
    "data-name": "Trazado 4389",
    d: "M234.369,111.8a8.578,8.578,0,1,1,0-17.156h30.313a8.578,8.578,0,1,1,0,17.156Z",
    transform: "translate(-224.541 -93.4)",
    fill: "#bde4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4390",
    "data-name": "Trazado 4390",
    d: "M264.929,96.135a7.333,7.333,0,1,1,0,14.667H234.616a7.333,7.333,0,1,1,0-14.667Zm0-2.49H234.616a9.823,9.823,0,1,0,0,19.646h30.313a9.823,9.823,0,1,0,0-19.646",
    transform: "translate(-224.786 -93.645)",
    fill: "#887db3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3185",
    "data-name": "Grupo 3185",
    transform: "translate(1.246 129.118)",
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3184",
    "data-name": "Grupo 3184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3183",
    "data-name": "Grupo 3183",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4391",
    "data-name": "Trazado 4391",
    d: "M8.292,189.361A7.266,7.266,0,0,1,1,182.137v-4.363a1.246,1.246,0,0,1,1.241-1.245l46.05-.205,17.8-68.951a4.885,4.885,0,0,1,4.741-3.649H185.254a4.882,4.882,0,0,1,3.838,1.842,4.8,4.8,0,0,1,.933,4.084l-17.4,75.933a4.86,4.86,0,0,1-4.771,3.777Z",
    transform: "translate(-1 -103.724)",
    fill: "#bde4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4392",
    "data-name": "Trazado 4392",
    d: "M185.5,105.214a3.616,3.616,0,0,1,3.557,4.4l-17.4,75.933a3.639,3.639,0,0,1-3.557,2.81H8.538a6.013,6.013,0,0,1-6.047-5.979v-4.363L49.5,177.81l18.041-69.881a3.641,3.641,0,0,1,3.534-2.715Zm0-2.49H71.077a6.13,6.13,0,0,0-5.947,4.582L47.57,175.329l-45.089.2A2.491,2.491,0,0,0,0,178.019v4.363a8.513,8.513,0,0,0,8.538,8.469H168.1a6.1,6.1,0,0,0,5.986-4.743l17.4-75.934a6.034,6.034,0,0,0-1.173-5.137,6.12,6.12,0,0,0-4.812-2.312",
    transform: "translate(-1.246 -103.969)",
    fill: "#887db3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4393",
    "data-name": "Trazado 4393",
    d: "M99.235,147.072a8.2,8.2,0,1,1,8.2-8.195,8.207,8.207,0,0,1-8.2,8.195",
    transform: "translate(21.126 -97.124)",
    fill: "#bde4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4394",
    "data-name": "Trazado 4394",
    d: "M99.481,132.171a6.951,6.951,0,1,1-6.955,6.95,6.952,6.952,0,0,1,6.955-6.95m0-2.49a9.44,9.44,0,1,0,9.447,9.44,9.454,9.454,0,0,0-9.447-9.44",
    transform: "translate(20.88 -97.369)",
    fill: "#887db3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4395",
    "data-name": "Trazado 4395",
    d: "M95.126,146.145A1.245,1.245,0,0,1,93.88,144.9V63.385a19.163,19.163,0,0,1,19.15-19.134h84.581a19.163,19.163,0,0,1,19.15,19.134V127.01a19.165,19.165,0,0,1-19.15,19.135Z",
    transform: "translate(23.071 10.834)",
    fill: "rgba(255,255,255,0.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4396",
    "data-name": "Trazado 4396",
    d: "M197.857,45.741a17.9,17.9,0,0,1,17.9,17.891v63.624a17.9,17.9,0,0,1-17.9,17.889H95.371V63.631a17.9,17.9,0,0,1,17.9-17.891Zm0-2.49H113.275a20.411,20.411,0,0,0-20.4,20.38v81.514a2.491,2.491,0,0,0,2.491,2.49H197.857a20.409,20.409,0,0,0,20.393-20.379V63.631a20.41,20.41,0,0,0-20.393-20.38",
    transform: "translate(22.825 10.589)",
    fill: "#887db3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3188",
    "data-name": "Grupo 3188",
    transform: "translate(182.548 113.347)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3187",
    "data-name": "Grupo 3187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3186",
    "data-name": "Grupo 3186",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_91",
    "data-name": "L\\xEDnea 91",
    x2: 18.943,
    y2: 19.646,
    transform: "translate(2.482 2.421)",
    fill: "#8ab9fa"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_92",
    "data-name": "L\\xEDnea 92",
    x2: 18.943,
    y2: 19.646,
    transform: "translate(2.482 2.421)",
    fill: "none",
    stroke: "#887db3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4400",
    "data-name": "Trazado 4400",
    d: "M.037.006l4.444,0L4.491,27.3l-4.444,0Z",
    transform: "translate(0.85 3.984) rotate(-43.935)",
    fill: "#8ab9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4401",
    "data-name": "Trazado 4401",
    d: "M.037.006l4.444,0L4.491,27.3l-4.444,0Z",
    transform: "translate(0.85 3.984) rotate(-43.935)",
    fill: "none",
    stroke: "#887db3",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3191",
    "data-name": "Grupo 3191",
    transform: "translate(151.332 81.738)",
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3190",
    "data-name": "Grupo 3190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3189",
    "data-name": "Grupo 3189",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4397",
    "data-name": "Trazado 4397",
    d: "M164.48,87.4a21.251,21.251,0,1,1-21.251-21.236A21.243,21.243,0,0,1,164.48,87.4",
    transform: "translate(-121.356 -65.54)",
    fill: "#7aabef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4398",
    "data-name": "Trazado 4398",
    d: "M164.48,87.4a21.251,21.251,0,1,1-21.251-21.236A21.243,21.243,0,0,1,164.48,87.4Z",
    transform: "translate(-121.356 -65.54)",
    fill: "none",
    stroke: "#887db3",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3194",
    "data-name": "Grupo 3194",
    transform: "translate(152.715 83.12)",
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3193",
    "data-name": "Grupo 3193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3192",
    "data-name": "Grupo 3192",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4399",
    "data-name": "Trazado 4399",
    d: "M163.57,87.248a20.491,20.491,0,1,1-20.491-20.476A20.484,20.484,0,0,1,163.57,87.248",
    transform: "translate(-122.589 -66.772)",
    fill: "#bde4f7"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_93",
    "data-name": "L\\xEDnea 93",
    x2: 32.251,
    transform: "translate(133.811 132.292)",
    fill: "none",
    stroke: "rgba(230,230,230,0.89)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_94",
    "data-name": "L\\xEDnea 94",
    x2: 49.618,
    transform: "translate(133.811 141.588)",
    fill: "none",
    stroke: "#8ab9fa",
    strokeWidth: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersNoResults);
export default __webpack_public_path__ + "static/media/FiltersNoResults.ade19f4980e416eb9333043019c38b0c.svg";
export { ForwardRef as ReactComponent };